module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_grzanie_1.119d3724.svg";